import { SET_SINGLE_APPOINTMENT } from '../actions/appointment';

const initialState = {
  singleAppointment: {},
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_SINGLE_APPOINTMENT: {
      return {
        ...state,
        singleAppointment: action.payload,
      };
    }

    default: {
      return state;
    }
  }
}
